<template>
  <div id="app">
    <Navigation />
    <main>
      <router-view />
    </main>
    <footer>
      <SiteFooter />
    </footer>
    <!-- Modal -->
    <div
      class="modal fade"
      id="galeria"
      tabindex="-1"
      role="dialog"
      aria-label="galeria"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered modal-xl" role="document">
        <div class="modal-content">
          <div class="modal-body">
            <Galeria />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Galeria from '@/components/Galeria'
import Navigation from '@/components/Navigation'
import SiteFooter from '@/components/SiteFooter'
export default {
  components: {
    Navigation,
    SiteFooter,
    Galeria,
  },
}
</script>

<style lang="scss">
.fade-leave-active,
.fade-enter-active {
  transition: opacity 500ms;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>
